import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, BookOpen } from "lucide-react";
import { Button } from "../components/ui/button";
import api from "../lib/api";

export default function HelpPage() {
  const [sections, setSections] = useState([]);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    api.get("/manual").then((r) => setSections(r.data.sections));
  }, []);

  const downloadPdf = async () => {
    setDownloading(true);
    try {
      const r = await api.get("/manual/pdf", { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "VTZ-CashFlow-Upute.pdf";
      a.click();
      URL.revokeObjectURL(url);
      toast.success("PDF upute preuzete");
    } catch {
      toast.error("Greška pri preuzimanju");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="space-y-6 fade-up max-w-4xl" data-testid="help-page">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#64748B] mb-1">Kako koristiti program</p>
          <h1 className="font-heading text-4xl font-bold tracking-tight text-[#0F172A]">Upute</h1>
        </div>
        <Button data-testid="download-manual-pdf-btn" onClick={downloadPdf} disabled={downloading} className="bg-[#0D9488] hover:bg-[#0F766E] rounded-sm">
          <Download className="w-4 h-4 mr-2" /> {downloading ? "Preuzimanje..." : "Preuzmi PDF upute"}
        </Button>
      </div>

      <div className="space-y-4">
        {sections.map((s) => (
          <section key={s.title} className="bg-white border border-[#E2E8F0] rounded-sm p-6" data-testid={`help-section-${s.title.slice(0, 1)}`}>
            <h2 className="font-heading text-lg font-semibold text-[#0F172A] mb-3 flex items-center gap-2">
              <BookOpen className="w-4 h-4 text-[#0D9488]" /> {s.title}
            </h2>
            <ul className="space-y-2">
              {s.items.map((it, i) => (
                <li key={i} className="flex gap-2 text-sm text-[#2E3A46] leading-relaxed">
                  <span className="text-[#0D9488] shrink-0">•</span> {it}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
